import { render, staticRenderFns } from "./quesGuide22.vue?vue&type=template&id=b07ef9f6"
import script from "./quesGuide22.vue?vue&type=script&lang=js"
export * from "./quesGuide22.vue?vue&type=script&lang=js"
import style0 from "./quesGuide22.vue?vue&type=style&index=0&id=b07ef9f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports